!(function () {
  'use strict';
  var t,
    e,
    i,
    n = {
      456: function (t, e, i) {
        var n = i(4306),
          a = i(8764),
          r = i(4394),
          o = i(8678);
        i(6486);
        const { fetch: s } = i.g;
        i(1955);
        const { CART: c, CUSTOMER_EMAIL: d, SHOPIFY_DOMAIN: l, GLOBALS: u } = window;
        n.Z.store('main', {
          shopifyDomain: l,
          customerEmail: d,
          globals: u,
          activeProductVariantId: null,
          isMiniCartOpen: !1,
          currentDropdown: null,
          isNavOpen: !1,
          isMobileNavOpen: !1,
          isNavigatingToCheckout: !1,
          isSearchOpen: !1,
          isScrolled: !1,
          hasCustomerSeenLandingPage: !1,
          showWaitlistModal: !1,
          cart: c || null,
          pendingUpdateVariantId: null,
          pendingAddVariantId: null,
          addedVariantIds: [],
          isCartUpdating: !1,
          cartErrorMessage: null,
          init() {
            '?cart=open' === window.location.search && (this.isMiniCartOpen = !0),
              this.onScroll(),
              document.addEventListener('scroll', () => {
                this.onScroll();
              }),
              location.hash &&
                addEventListener('load', () => {
                  const t = document.getElementById(location.hash.replace('#', ''));
                  t &&
                    setTimeout(() => {
                      t.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                });
            const t = document.querySelector('.product-form'),
              e = document.querySelector('.buy-button');
            let i;
            e &&
              (i = new IntersectionObserver((t) => {
                t.forEach((t) => {
                  t.boundingClientRect.bottom < 0 ? e.classList.add('active') : e.classList.remove('active');
                });
              })),
              t && i.observe(t);
          },
          testClick() {},
          onScroll() {
            window.scrollY > 100
              ? '#47FF70' !== document.body.style.background && (document.body.style.background = '#47FF70')
              : '#FAFCFC' !== document.body.style.background && (document.body.style.background = '#FAFCFC');
          },
          setMiniCartOpen(t) {
            (this.isMiniCartOpen = t),
              (this.isSearchOpen = !1),
              (this.isMobileNavOpen = !1),
              this.isMiniCartOpen
                ? document.documentElement.classList.add('overflow-hidden')
                : document.documentElement.classList.remove('overflow-hidden');
          },
          closeMenus() {
            (this.isNavOpen = !1), (this.isMobileNavOpen = !1), (this.isSearchOpen = !1), (this.currentDropdown = null);
          },
          setActiveVariantId(t) {
            this.activeProductVariantId = t;
            // window.history &&
            //   window.history.replaceState &&
            //   window.history.replaceState({}, window.title, `${window.location.pathname}?variant=${t}`);
          },
          validateEmail(t) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              t
            );
          },
          gtagItemFromLine(t) {
            let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return {
              item_id: t.sku || t.id,
              item_name: t.product_title,
              currency: 'USD',
              item_brand: t.vendor,
              item_category: t.product_type,
              item_variant: t.title,
              discount: t.total_discount ? t.total_discount / 100 : 0,
              price: t.final_price ? t.final_price / 100 : 0,
              quantity: e,
            };
          },
          async addVariant(t) {
            let { id: e, selling_plan: i, quantity: n = 1, properties: a = null, openCart: r = !0 } = t;
            this.pendingAddVariantId = e;
            const o = { id: e, quantity: n, selling_plan: i };
            a && (o.properties = a), await this.addVariants({ items: [o], openCart: r });
          },
          async addVariants(t) {
            let { items: e, openCart: i = !0 } = t;
            try {
              const t = await ((t) =>
                  s('/cart/add.js', {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: t }),
                  }))(e),
                n = await t.json();
              if (n.items) {
                const t = n.items,
                  e = this.cart.items;
                for (let i = 0; i < t.length; i++) {
                  const n = t[i],
                    a = e.find((t) => t.key == n.key);
                  a ? (a.quantity = n.quantity) : e.unshift(n);
                }
                (this.pendingAddVariantId = null),
                  (this.cart = { ...this.cart, ...this.calculateItems(e) }),
                  _learnq &&
                    _learnq.push([
                      'track',
                      'Added to Cart',
                      {
                        total_price: this.cart.total_price / 100,
                        $value: this.cart.total_price / 100,
                        total_discount: this.cart.total_discount,
                        original_total_price: this.cart.original_total_price / 100,
                        items: this.cart.items,
                      },
                    ]),
                  i && this.setMiniCartOpen(!0);
              } else if (n.description) throw (alert(n.description), new Error(n.description));
              i && this.setMiniCartOpen(!0);
            } catch (t) {
              throw (console.error(t), (this.pendingAddVariantId = null), t);
            }
          },
          calculateItems(t) {
            return {
              item_count: t.reduce((t, e) => t + (e.quantity || 0), 0),
              total_price: t.reduce((t, e) => t + (e.discounted_price || 0) * e.quantity, 0),
            };
          },
          updateVariantQuantity(t, e) {
            return (
              (this.pendingUpdateVariantId = t),
              (function (t) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                return s('/cart/change.js', {
                  method: 'POST',
                  credentials: 'include',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: `${t}`, quantity: e }),
                });
              })(t, e)
                .then((e) =>
                  e.ok
                    ? e.json()
                    : (this.setCartError(t),
                      Promise.reject(
                        'Unable to increase the carted quantity of the item. Most likely the available inventory quantity is already reached.'
                      ))
                )
                .then((t) => {
                  (this.pendingUpdateVariantId = null), (this.cart = t);
                })
                .catch((t) => {
                  throw ((this.pendingUpdateVariantId = null), t);
                })
            );
          },
          async navigateToCheckout() {
            (this.isNavigatingToCheckout = !0),
              await this.fetchCart(),
              (window.location = '/checkout'),
              (this.isNavigatingToCheckout = !1);
          },
          setSearchOpen(t) {
            (this.isSearchOpen = t),
              (this.isMobileNavOpen = !t && this.isMobileNavOpen),
              (this.isMiniCartOpen = !t && this.isMiniCartOpen);
          },
          fetchCart() {
            return (
              (this.isCartUpdating = !0),
              s('/cart.json')
                .then((t) => t.json())
                .then((t) => {
                  (this.isCartUpdating = !1), (this.cart = t);
                })
                .catch((t) => {
                  throw ((this.isCartUpdating = !1), t);
                })
            );
          },
          async updateCartAttributes(t) {
            this.isCartUpdating = !0;
            const e = this.cart.attributes,
              i = { ...this.cart.attributes, ...t };
            this.cart.attributes = i;
            try {
              const t = await (function () {
                  let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  return s('/cart/update.js', {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: t }),
                  });
                })(i),
                e = await t.json();
              (this.isCartUpdating = !1), (this.cart = e);
            } catch (t) {
              console.error(t), (this.cart.attributes = e), (this.isCartUpdating = !1);
            }
          },
          clearCart() {
            return s('/cart/clear.js', {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
            });
          },
          graphQl(t) {
            return ((t) =>
              s('/api/2022-10/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Shopify-Storefront-Access-Token': 'TOKEN',
                },
                body: JSON.stringify({ query: t }),
              }).then((t) => t.json()))(t);
          },
        }),
          n.Z.data('select', () => ({
            init() {
              this.$nextTick(() => {
                new Choices(this.$refs.select, { searchEnabled: !1, itemSelectText: '', placeholder: !0 });
              });
            },
          })),
          n.Z.data('productForm', (t, e, i) => {
            const a =
                (function () {
                  let t;
                  const e = new URLSearchParams(location.search);
                  for (const [i, n] of e) 'variant' === i && n && (t = n);
                  return t;
                })() || e,
              r = t.find((t) => t.id == (i ? a : e));
            i && n.Z.store('main').setActiveVariantId(r.id);
            const o = n.Z.reactive({ activeVariant: r });
            return (
              n.Z.effect(() => {
                const e = n.Z.store('main').activeProductVariantId;
                if (i) {
                  const i = t.find((t) => t.id == e);
                  i && (o.activeVariant = i);
                }
              }),
              {
                isOptionValueSelected(t, e) {
                  return (
                    (t = parseInt(t.replace('option', '')) - 1), this.reactiveData.activeVariant?.optionValues[t] == e
                  );
                },
                isOptionAvailable(t, e) {
                  t = parseInt(t.replace('option', '')) - 1;
                  const i = [...this.reactiveData.activeVariant.optionValues];
                  i[t] = e;
                  const n = this.variants.find((t) => JSON.stringify(t.optionValues) == JSON.stringify(i));
                  return !!n && n.isAvailable;
                },
                onOptionChanged(t, e) {
                  t = parseInt(t.replace('option', '')) - 1;
                  const a = [...this.reactiveData.activeVariant.optionValues];
                  a[t] = e;
                  const r = this.variants.find((t) => JSON.stringify(t.optionValues) == JSON.stringify(a));
                  r && (i && n.Z.store('main').setActiveVariantId(r.id), (this.reactiveData.activeVariant = r));
                },
                changeActiveVariant(t) {
                  const e = this.variants.find((e) => e.id == t);
                  e && i && n.Z.store('main').setActiveVariantId(e.id), (this.reactiveData.activeVariant = e);
                },
                increaseQuantity() {
                  this.quantity++;
                },
                decreaseQuantity() {
                  this.quantity > 1 && this.quantity--;
                },
                reactiveData: o,
                variants: t,
                quantity: 1,
              }
            );
          }),
          n.Z.directive('price', (t, e, i) => {
            let { expression: n } = e,
              { evaluateLater: a, effect: r } = i,
              o = a(n);
            r(() => {
              o((e) => {
                t.innerHTML = ((t) => ((t / 100) % 1 == 0 ? '$' + t / 100 : `$${(t / 100).toFixed(2)}`))(e);
              });
            });
          }),
          n.Z.plugin(a.Z),
          n.Z.plugin(r.Z),
          n.Z.plugin(o.Z),
          (window.Alpine = n.Z),
          window.Alpine.start();
        const { HYDRATE_VARIANT_ID: h } = window,
          p = new URLSearchParams(window.location.search),
          f = Object.fromEntries(p.entries()),
          v = Number(f.variant) || h;
        v && Alpine.store('main').setActiveVariantId(v);
      },
      720: function () {},
    },
    a = {};
  function r(t) {
    var e = a[t];
    if (void 0 !== e) return e.exports;
    var i = (a[t] = { id: t, loaded: !1, exports: {} });
    return n[t].call(i.exports, i, i.exports, r), (i.loaded = !0), i.exports;
  }
  (r.m = n),
    (t = []),
    (r.O = function (e, i, n, a) {
      if (!i) {
        var o = 1 / 0;
        for (l = 0; l < t.length; l++) {
          (i = t[l][0]), (n = t[l][1]), (a = t[l][2]);
          for (var s = !0, c = 0; c < i.length; c++)
            (!1 & a || o >= a) &&
            Object.keys(r.O).every(function (t) {
              return r.O[t](i[c]);
            })
              ? i.splice(c--, 1)
              : ((s = !1), a < o && (o = a));
          if (s) {
            t.splice(l--, 1);
            var d = n();
            void 0 !== d && (e = d);
          }
        }
        return e;
      }
      a = a || 0;
      for (var l = t.length; l > 0 && t[l - 1][2] > a; l--) t[l] = t[l - 1];
      t[l] = [i, n, a];
    }),
    (i = Object.getPrototypeOf
      ? function (t) {
          return Object.getPrototypeOf(t);
        }
      : function (t) {
          return t.__proto__;
        }),
    (r.t = function (t, n) {
      if ((1 & n && (t = this(t)), 8 & n)) return t;
      if ('object' == typeof t && t) {
        if (4 & n && t.__esModule) return t;
        if (16 & n && 'function' == typeof t.then) return t;
      }
      var a = Object.create(null);
      r.r(a);
      var o = {};
      e = e || [null, i({}), i([]), i(i)];
      for (var s = 2 & n && t; 'object' == typeof s && !~e.indexOf(s); s = i(s))
        Object.getOwnPropertyNames(s).forEach(function (e) {
          o[e] = function () {
            return t[e];
          };
        });
      return (
        (o.default = function () {
          return t;
        }),
        r.d(a, o),
        a
      );
    }),
    (r.d = function (t, e) {
      for (var i in e) r.o(e, i) && !r.o(t, i) && Object.defineProperty(t, i, { enumerable: !0, get: e[i] });
    }),
    (r.e = function () {
      return Promise.resolve();
    }),
    (r.g = (function () {
      if ('object' == typeof globalThis) return globalThis;
      try {
        return this || new Function('return this')();
      } catch (t) {
        if ('object' == typeof window) return window;
      }
    })()),
    (r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (r.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (r.nmd = function (t) {
      return (t.paths = []), t.children || (t.children = []), t;
    }),
    (r.j = 6348),
    (function () {
      var t = { 6348: 0 };
      r.O.j = function (e) {
        return 0 === t[e];
      };
      var e = function (e, i) {
          var n,
            a,
            o = i[0],
            s = i[1],
            c = i[2],
            d = 0;
          if (
            o.some(function (e) {
              return 0 !== t[e];
            })
          ) {
            for (n in s) r.o(s, n) && (r.m[n] = s[n]);
            if (c) var l = c(r);
          }
          for (e && e(i); d < o.length; d++) (a = o[d]), r.o(t, a) && t[a] && t[a][0](), (t[a] = 0);
          return r.O(l);
        },
        i = (self.webpackChunkbf_shopify_os2 = self.webpackChunkbf_shopify_os2 || []);
      i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
    })(),
    r.O(void 0, [1216], function () {
      return r(456);
    });
  var o = r.O(void 0, [1216], function () {
    return r(720);
  });
  o = r.O(o);
})();
